export const langTabMeteo = {
    fr: {
      sessionStart: 'Début session',
      sessionEnd: 'Fin session',
      sessionCoord: 'Localisation spot',
    },
    eng: {
        sessionStart: 'Session start',
        sessionEnd: 'Session end',
        sessionCoord: 'Spot location',
      },
    }
